export default __webpack_public_path__ + "static/media/St Lawrence College.7751362c.png";